var MarkdownTestIdEnum = /* @__PURE__ */ ((MarkdownTestIdEnum2) => {
  MarkdownTestIdEnum2["MARKDOWN_CONTAINER"] = "markdown--container";
  MarkdownTestIdEnum2["MARKDOWN_CONTENT"] = "markdown--content";
  return MarkdownTestIdEnum2;
})(MarkdownTestIdEnum || {});
export {
  MarkdownTestIdEnum
};
